<template>
  <el-dialog
    class="modal-order-view"
    title="订单详情"
    :visible.sync="visible"
    @close="$_close"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="greater"
  >
    <div class="content" v-loading="isLoading" element-loading-spinner="el-icon-loading">
      <div class="order-price">
        <table>
          <tr class="price">
            <td>{{postData.price}}元</td>
            <td>{{postData.counts}}份</td>
            <td>{{postData.deliveryFee}}元</td>
            <td>{{postData.mealFee}}元</td>
            <td>{{postData.discountPrice}}元</td>
          </tr>
          <tr class="price-title">
            <td>订单总金额</td>
            <td>餐品份数</td>
            <td>配送费</td>
            <td>餐盒费</td>
            <td>优惠总金额</td>
          </tr>
        </table>
      </div>

      <div class="order-detail">
        <div class="classification">
          <div class="row">
            <span>统一门店id：{{postData.storeId || '-'}}</span>
            <span>下单渠道：{{postData.fromTypeName || '-'}}</span>
            <span>门店名称：{{postData.storeName || '-'}}</span>
          </div>

          <div class="row">
            <span>外卖平台订单号：{{postData.extOrderId || '-'}}</span>
            <span>系统订单号：{{postData.orderId || '-'}}</span>
            <span>第三方订单号：{{postData.subOrderId || '-'}}</span>
          </div>
        </div>

        <div class="classification">
          <div class="row">
            <span>业务类型：{{postData.orderTypeDesc || '-'}}</span>
            <span>下单时间：{{postData.orderTime || '-'}}</span>
            <span>送达时间：{{postData.sendTime || '-'}}</span>
          </div>

          <div class="row">
            <span>订餐人：{{postData.name || '-'}}</span>
            <span>联系电话：{{postData.phone || '-'}}</span>
          </div>

          <div class="row">
            <span>送餐地址：{{postData.address || '-'}}</span>
          </div>

          <div class="row">
            <span>客户备注：{{postData.userNote || '-'}}</span>
          </div>
        </div>

        <div class="classification">
          <div class="row">
            <span>是否支付：{{postData.isPayed ? '是': postData.isPayed === false ? '否' : '-'}}</span>
          </div>

          <div class="row" v-for="(config, index) in postData.paymentDetails" :key="index">
            <span>付款类型：{{config.typeName || '-'}}</span>
            <span>支付金额：{{config.money || '-'}}</span>
          </div>

          <div class="row" v-if="postData.paymentDetails === undefined">
            <span>付款类型：{{ '-'}}</span>
            <span>支付金额：{{'-'}}</span>
          </div>

          <div class="row">
            <span>是否开发票：{{postData.isInvoice ? '是': postData.isInvoice === false ? '否' : '-'}}</span>
            <!-- <span>发票类型：{{postData.}}</span> -->
            <span>发票抬头：{{postData.invoiceDesc || '-'}}</span>
            <span>发票税号：{{postData.taxNo || '-'}}</span>
          </div>

          <div class="row">
            <span>是否平台配送：{{postData.isThirdDistribute ? '是': postData.isThirdDistribute === false ? '否' : '-'}}</span>
          </div>
        </div>

        <div class="classification">
          <div class="row">
            <!-- <span>配送公司：{{postData.shift || '-'}}</span> -->
            <span>骑手姓名：{{postData.riderName || '-'}}</span>
            <span>骑手电话：{{postData.riderPhone || '-'}}</span>
            <span>骑手状态：{{postData.driverStatus || '-'}}</span>
          </div>
        </div>
      </div>

      <div class="product-info">
        <div>
          <span class="product-title">餐品信息</span>
        </div>
        <el-table class="table-list__box" :data="list" stripe border tooltip-effect="dark">
          <el-table-column label width="8" :resizable="false"></el-table-column>
          <el-table-column
            v-for="column in columns"
            :key="column.key"
            :prop="column.key"
            :label="column.label"
            :width="column.width"
            filter-placement="bottom"
            show-overflow-tooltip
            sortable
          ></el-table-column>
        </el-table>
      </div>

      <div class="product-info" v-if="list2.length > 0 ">
        <div>
          <span class="product-titles">套餐</span>
        </div>
        <el-table class="table-list__box" :data="list2" stripe border tooltip-effect="dark">
          <el-table-column label width="8" :resizable="false"></el-table-column>
          <el-table-column
            v-for="column in colum"
            :key="column.key"
            :prop="column.key"
            :label="column.label"
            :width="column.width"
            filter-placement="bottom"
            sortable
          ></el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancel__btn" @click="$_close">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "modal-order-view",
  props: {
    postData: { type: Object, default: () => {} }
  },
  data() {
    return {
      visible: false,
      isLoading: true,
      data: {},
      products: [],
      columns: [
        { key: "pid", label: "统一餐品id", width: 180 },
        { key: "name", label: "餐品名称", width: 160 },
        { key: "onePrice", label: "单价", width: 180 },
        { key: "num", label: "数量", width: 180 },
        { key: "totalPrice", label: "总价" }
      ],
      colum: [
        { key: "pid", label: "统一餐品id", width: 180 },
        { key: "name", label: "餐品名称", width: 160 },
        { key: "skuprice", label: "单价", width: 180 },
        { key: "num", label: "数量", width: 180 },
        { key: "totalPrice", label: "总价" }
      ]
    };
  },
  computed: {
    list() {
      this.postData.products.map(item => {
        let newArr = 0;
        if (item.skus == undefined) {
          //             return []
        } else {
          item.skus.map(index => {
            newArr = index.price;
          });
        }
        this.$set(item, "totalPrice", 0);
        this.$set(item, "onePrice", 0);
        item.onePrice = item.price + newArr;
        item.totalPrice = item.num * item.onePrice;
      });
      return this.postData.products;
    },

    list2() {
      let newArr = [];
      let skus = [];
      this.postData.products.map(items => {
        if (items.combos == undefined) {
          //           return []
        } else {
          items.combos.map(index => {
            if (index.skus == undefined) {
              //             return []
            } else {
              index.skus.map(sku => {
                skus = sku.price;
                return skus;
              });
            }
            this.$set(index, "skuprice", 0);
            this.$set(index, "totalPrice", 0);
            index.skuprice = index.price + skus;
            index.totalPrice = index.num * index.skuprice;
            newArr.push(index);
            return newArr;
          });
        }
      });
      return newArr;
    }
  },
  methods: {
    $_close() {
      this.visible = false;
      this.$emit("close");
    }
  },
  mounted() {
    this.visible = true;
    this.isLoading = false;
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: {
    top: 18px;
    bottom: 20px;
    left: 30px;
    right: 36px;
  }
  overflow-y: auto;

  .order-price,
  .order-detail {
    border-bottom: 1px solid #e6e6e6;
  }
  .order-price {
    padding-bottom: 8px;
    table {
      width: 100%;
    }
    td {
      width: 20%;
      text-align: center;
      padding: 0 5px;
      word-wrap: break-word;
      word-break: break-all;
    }
    .price {
      td {
        font-size: 14px;
        font-weight: bolder;
        color: #535353;
      }
    }
    .price-title {
      td {
        color: #898989;
      }
    }
  }
  .order-detail {
    padding-top: 15px;
    padding-bottom: 5px;
    .classification {
      margin-bottom: 5px;
      padding-left: 10px;
      margin-right: -20px;
      position: relative;

      &::before {
        display: inline-block;
        content: "";
        width: 4px;
        height: 12px;
        background: #1895dd;
        position: absolute;
        left: 0;
        top: 3px;
      }

      .row {
        & > span {
          display: inline-block;
          min-width: 25%;
          padding-right: 20px;
          word-wrap: break-word;
          word-break: break-all;
          padding-bottom: 8px;
        }
      }
      .rows {
        & > span {
          display: inline-block;
          min-width: 25%;
          padding-right: 20px;
          word-wrap: break-word;
          word-break: break-all;
          padding-bottom: 8px;
          font-weight: 600;
        }
      }
    }
  }

  .product-info {
    .product-title {
      display: inline-block;
      margin-bottom: 10px;
      margin-top: 20px;
      width: 80px;
      height: 25px;
      border-radius: 12px;
      background: #1895dd;
      text-align: center;
      line-height: 25px;
      color: #fff;
    }

    .table-list__box {
      border: 1px solid #e6e6e6;
      border-right: none;
    }
  }
}
.product-titles {
  display: inline-block;
  margin-bottom: 10px;
  margin-top: 20px;
  width: 80px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  font-size: 14px;
  color: #3a3a3a;
}
</style>


